module.exports = __webpack_public_path__ + "img/whatsapp.e77b0825.svg";